import { render, staticRenderFns } from "./targetGroup.vue?vue&type=template&id=260e5fb5&"
import script from "./targetGroup.vue?vue&type=script&lang=js&"
export * from "./targetGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports